import { Flex, Text, Button } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';

export const LectureAds: FC = () => {
  return (
    <Flex
      boxSizing="border-box"
      flexDirection="column"
      alignItems="flex-start"
      p={6}
      background="linear-gradient(90deg, rgba(225, 121, 241, 0.1) 0%, rgba(189, 138, 245, 0.1) 26.56%, rgba(112, 181, 239, 0.1) 50%, rgba(91, 197, 223, 0.1) 74.48%, rgba(82, 163, 176, 0.1) 98.96%)"
      borderRadius="16px"
      border="3px solid"
      borderColor="rgba(189, 138, 245, 1)"
    >
      <Text fontSize="lg" fontFamily="body">
        Would you like to see your presentation here, made available to a global audience of researchers?
        <br />
        Add your own presentation or have us affordably record your next conference.
      </Text>
      <Flex flexDirection={{ base: 'column', lg: 'row' }} mt={6} gap={6}>
        <NextLink target="_blank" href="/researchers" passHref>
          <Button size="sm">Add your own presentation</Button>
        </NextLink>
        <NextLink target="_blank" href="/publishers" passHref>
          <Button size="sm">Record your next conference</Button>
        </NextLink>
      </Flex>
    </Flex>
  );
};
